import React from 'react';

const errorData = {
    77: {
        title: 'Aguarde, estamos preparando o seu arquivo',
        content: (
            <>
                Isso pode levar alguns minutos de acordo com o tamanho do relatório. Tente novamente mais tarde.
                <br />
                <br />
                <b>Importante:</b> nosso sistema reinicia após 30 minutos de inatividade. Retorne antes disso para
                evitar perder seus relatórios.
            </>
        ),
    },
    118: {
        title: 'Não foi possível obter dados para o relatório',
        content: (
            <>
                Os filtros informados não obteve dados para geração do relatório.
                <br />
                <br />
                <b>Importante:</b> verifique os filtros informados e tente novamente.
            </>
        ),
    },
    '-1': {
        title: 'Erro ao processar o relatório',
        content: <>Por gentileza, solicitar novo relatório.</>,
    },
};

export default errorData;
